"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _StyledCheckbox = require("./StyledCheckbox");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
  function CheckboxGroup() {
    var _this;
    (0, _classCallCheck2.default)(this, CheckboxGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CheckboxGroup, [].concat(args));
    (0, _defineProperty2.default)(_this, "handleChange", function (e) {
      var value = e.target.value;
      var optionIndex = _this.props.value.indexOf(value);
      var newSelectedValues = (0, _toConsumableArray2.default)(_this.props.value);
      if (optionIndex === -1) {
        newSelectedValues.push(value);
      } else {
        newSelectedValues.splice(optionIndex, 1);
      }
      if (_this.props.onChange) {
        _this.props.onChange(newSelectedValues);
      }
    });
    return _this;
  }
  (0, _inherits2.default)(CheckboxGroup, _React$Component);
  return (0, _createClass2.default)(CheckboxGroup, [{
    key: "renderCheckboxes",
    value: function renderCheckboxes() {
      var _this2 = this;
      return this.props.items.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          key: item.value,
          id: item.id,
          textLabel: item.textLabel,
          onChange: _this2.handleChange,
          value: item.value,
          checked: _this2.props.value.indexOf(item.value) !== -1,
          disabled: item.disabled || _this2.props.disabled,
          vertical: _this2.props.vertical,
          style: item.style
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_StyledCheckbox.StyledCheckboxGroup, {
        id: this.props.id
      }, this.renderCheckboxes());
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(CheckboxGroup, "defaultProps", {
  items: [],
  value: [],
  defaultValue: [],
  vertical: false,
  disabled: false
});
(0, _defineProperty2.default)(CheckboxGroup, "propTypes", {
  defaultValue: _propTypes.default.array,
  value: _propTypes.default.array,
  items: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func,
  vertical: _propTypes.default.bool,
  disabled: _propTypes.default.bool
});
CheckboxGroup.displayName = 'CheckboxGroup';
var _default = exports.default = (0, _inputHOC.default)(CheckboxGroup);